<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择库存"
    top="5vh"
    width="1100px"
  >
    <TableSelect
      ref="tableSelect"
      :filter="filter"
      :columns="columns"
      module="basic"
      url="stockDetails/kingdee"
      @select="selectHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable />
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        materialNo: "",
        materialName: "",
      },
      materialNoCopy: "",
      columns: [
        {
          title: "物料编号",
          key: "materialNo",
          width: 120,
          align: "center",
        },
        {
          title: "物料名称",
          key: "materialName",
          minWidth: 360,
        },
        {
          title: "仓库名称",
          key: "warehouseName",
          width: 140,
        },
        {
          title: "仓位名称",
          key: "locationName",
          width: 140,
        },
        {
          title: "数量",
          key: "baseQuantity",
          width: 90,
          align: "center",
        },
        {
          title: "单位",
          key: "unitName",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open(materialNo) {
      this.dialogVisible = true;
      this.materialNoCopy = materialNo;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.filter.materialNo = materialNo;
        this.$refs.tableSelect.loadData();
      });
    },

    selectHandle(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
      this.filter.materialNo = this.materialNoCopy;
      this.$refs.tableSelect.loadData();
    },
  },
};
</script>
